import index from "./shareToMessenger.vue";
export default index;
